import Bugsnag from '@bugsnag/js';
import { ZodError } from 'zod';

/**
 * Handles logging any and all errors to Bugsnag. Call this instead of 'Bugsnag.notify' whenever
 * you would log an error.
 */
export function logError(error: unknown) {
  const isZodError = error instanceof ZodError;
  if (import.meta.env.MODE === 'development') {
    if (isZodError) {
      console.error('Validation issues: ', error.issues);
    }
    console.error(error);
  }
  if (isZodError) {
    Bugsnag.notify(error);
    return;
  }
  if (error instanceof Error) {
    Bugsnag.notify(error);
    return;
  }
  Bugsnag.notify(String(error));
}
